import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./sliders.css";

import Slider from "./Slider";
import MegaSlider from "./megaSlider";

// sliders in sidebar
const maxIndex = 2;
export default function Sliders({ toggleExtensionCollapse }) {
  const [megaSliderMasters, setMegaSliderMasters] = useState([]);

  const { megaSlider } = useSelector((state) => state.sidebarSliders);
  const { activityTypes } = useSelector((state) => state.activityTypes);
  const { categories } = useSelector((state) => state.activityCategories);
  const selectedCategory = categories.find((category) => category.isSelected === true);
  const { selectedCategoryName } = useSelector((state) => state.activityCategories);

  let selectedActivityTypes = selectedCategoryName === 'Video Activity' ? activityTypes.filter(type => type.isSelected === true) : activityTypes.filter((type) => type.isSelected === true && type.activity_category_id === selectedCategory.id);

  useEffect(() => {
    if (megaSlider.active === false) return;
    selectedActivityTypes.map((type) => {
      type.id === megaSlider.activityTypeId &&
        type.subtypes.map((subtype) => {
          if (subtype.id === megaSlider.activitySubtypeId) {
            setMegaSliderMasters(subtype.masters_data);
          }
        });
    });
  }, [megaSlider.active]);

  // useEffect(() => {
  //   if (selectedCategoryName === 'Video Activity') {
  //     selectedActivityTypes = activityTypes.filter(type => type.isSelected === true)
  //   }
  // }, [selectedCategoryName, activityTypes])

  if (activityTypes.length < 1) {
    return <></>;
  }
  return (
    <div className="sidebar_extension__sliders">
      {/* <div className="rectangle" ></div> */}
      {!megaSlider.active ? (
        <div>
          {/* <Slider isTrending={true} data={trendingThemes} header='Trending' /> */}
          <div>
            {selectedActivityTypes.map((activityType) => {
              return activityType.subtypes.map((subtype) => {
                let data = subtype.masters_data
                if (data?.length > 5) {
                  data = data.filter((item, idx) => idx <= 4)
                }
                // selectedCategoryName === 'Video Activity'
                // console.log('mster len', subtype.masters_data.length);
                let isLoadMoreVisible = subtype.masters_data.length > 2 ? true : false;
                return (
                  <Slider
                    key={subtype.id}
                    data={data}
                    header={subtype.name}
                    toggleExtensionCollapse={toggleExtensionCollapse}
                    activityTypeId={activityType.id}
                    subtypeId={subtype.id}
                    isSidebarMaster={true}
                    isLoadMoreVisible={isLoadMoreVisible}
                    activityTypeName={activityType.name}
                    subtypeName={subtype.name}
                  />
                );
              });
            })}
          </div>
        </div>
      ) : (
        <MegaSlider
          megaSliderMasters={megaSliderMasters}
          //  activityTypeName={megaSlider.activityTypeName}
          //  subtypeName={megaSlider.subtypeName}
          {...megaSlider}
          setMegaSliderMasters={setMegaSliderMasters}
        />
      )}
    </div>
  );
}
